module.exports = __webpack_public_path__ + "img/1497914854.69279af1.jpg";